import loadable from '../../utilities/loadable'

export const MarketplaceAdCardWidget = loadable(() =>
  import('./MarketplaceAdCardWidget')
)
